import React from 'react';
import { Container, Box } from '@mui/material';

import {
  VehicleModelDetailsSkeleton,
  VehicleModelLocationDetailsSkeleton,
  ReviewSectionSkeleton,
} from 'views/VehicleModelView/components';

export const VehicleModelViewSkeleton = () => (
  <Container maxWidth="xl">
    <Box my={3}>
      <VehicleModelDetailsSkeleton />
      <VehicleModelLocationDetailsSkeleton />
      <ReviewSectionSkeleton />
    </Box>
  </Container>
);
